import { render, staticRenderFns } from "./vip_login.vue?vue&type=template&id=214ef273&scoped=true"
import script from "./vip_login.vue?vue&type=script&lang=js"
export * from "./vip_login.vue?vue&type=script&lang=js"
import style0 from "./vip_login.vue?vue&type=style&index=0&id=214ef273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ef273",
  null
  
)

export default component.exports